import { LocalChannel } from '@core/models';
import { JuvoTrackSession } from '../interfaces';

export function requireLocalChannelByCode(channels: LocalChannel[], code: string): LocalChannel {
	const channel = channels.find(localChannel => localChannel.codigo === code);
	if (!channel) {
		throw new Error(`No local canal found with codigo ${code}`);
	}

	return channel;
}

export function getJuvoTrackSessionChannels(channels: LocalChannel[] | null | undefined): LocalChannel[] {
	if (!channels?.[0]?.habilitado) {
		return [{ habilitado: false } as LocalChannel];
	}

	return channels;
}

export function shouldUpdateAllStock(session: JuvoTrackSession | null): boolean {
	if (!session?.length) {
		return true;
	}

	return !session[0].habilitado;
}
